import React from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import SpinnerLoader from '../../Component/SpinnerLoader/SpinnerLoader';


const LogStatusActions = ({
  status,
  unique_id,
  handleAddNewScoreReBulk,
  deletePostingDataFunction,
}) => {
  return (
    <div className="top-[-4px] lg:top-auto h-10 justify-center flex absolute right-1 w-full">
      {status === 'failed' ? (
        <div className="flex justify-center items-center gap-2 absolute top-0 right-0 left-0 bottom-0">
          <button>
            <IconCollection
              name="error-info"
              customClass="lg:max-w-10 fill-black max-w-[8px] w-full lg:h-10 h-[8px]"
            />
          </button>
          <button onClick={() => handleAddNewScoreReBulk(unique_id)}>
            <IconCollection
              name="reload-icon-black"
              customClass="lg:max-w-10 fill-black max-w-[8px] w-full lg:h-10 h-[8px]"
            />
          </button>
          <button onClick={() => deletePostingDataFunction(unique_id)}>
            <IconCollection
              name="delete-icon-black"
              customClass="lg:max-w-10 fill-black max-w-[8px] w-full lg:h-10 h-[8px]"
            />
          </button>
        </div>
      ) : (
        <div className="flex justify-end gap-2 absolute right-1 w-full">
          <SpinnerLoader />
          <button
            className="delayed-button h-4 w-4 flex justify-center items-center"
            onClick={() => deletePostingDataFunction(unique_id)}
          >
            <IconCollection
              name="delete-icon-black-mini"
              customClass="lg:max-w-4 max-w-[8px] w-full lg:h-4 h-[8px]"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default LogStatusActions;
